/// Menu
//import Metismenu from "metismenujs";
import React, { useContext, useReducer, useState, useEffect } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
//import { Dropdown } from "react-bootstrap";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
//import LogoutPage from './Logout';
/// Image7
import {
  SubAdminMenuListWithInv,
} from "./Menu";
import { AdminMenuList } from "./Menu";
import AdminSidebar from "./AdminSidebar";
import VenueManagerSidebar from "./VenueManagerSidebar";
import { AuthContext } from "../../../context/AuthContext";
import UserSidebar from "./UserSidebar";
import { getAllUserProfileList } from "../../../services/userApiService/userService";
import { useMenu } from "../../../hooks/useMenu";
import { useMenuManagement } from "../../../context/MenuManagementContext";
import { toggleSidebar } from "../../../store/actions/UIActions";  
import { useDispatch, useSelector } from "react-redux";

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});
const initialState = {
  active: "",
  activeSubmenu: "",
};
const SideBar = () => {
  const { user, USER_LEVEL, userData } = useContext(AuthContext);
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state.ui.isSidebarOpen);
  const userCategoryMain = localStorage.getItem("user_category_main");
  const [userMenuList, setUserMenuList] = useState([
    {
      title: "Grievance Management",
      classsChange: "mm-collapse",
      iconStyle: <i class="bi bi-ticket-perforated-fill"></i>,
      content: [
        {
          title: "Tickets",
          to: "user-grievance-management/ticket",
        },
        // {
        //   title: "Notifications",
        //   to: "user-grievance-management/notification",
        // }
      ],
    },
    {
      title: "Notification Management",
      classsChange: "mm-collapse",
      iconStyle: <i class="bi bi-ticket-perforated-fill"></i>,
      content: [
        {
          title: "Notifications",
          to: "user-grievance-management/notification",
        },
      ],
    },
    {
      title: "Account Management",
      classsChange: "mm-collapse",
      iconStyle: <i class="bi bi-ticket-perforated-fill"></i>,
      content: [
        {
          title: "Edit Profile Request",
          to: "user/edit-profile-list",
        },
        {
          title: "Delete Account",
          to: "user/delete-account",
        },
      ],
    },
    {
      title: "Inventory Management",
      classsChange: "mm-collapse",
      iconStyle: <i className="fas fa-building" />,
      content: [
        {
          title: "Inventory List",
          to:
            process.env.REACT_APP_INVENTORY_MANAGEMENT_URL ||
            "https://staging-inventory.khelouk.in/",
        },
      ],
    },
    {
      title: "LMS Management",
      classsChange: "mm-collapse",
      iconStyle: <i className="fas fa-building" />,
      content: [
        {
          title: "LMS",
          to:
            process.env.REACT_APP_LMS_MANAGEMENT_URL
        },
      ],
    },
    {
      title: "Communication Management",
      classsChange: "mm-collapse",
      iconStyle: <i className="fas fa-comments" />,
      content: [
        {
          title: "Forum & Chat",
          to: process.env.REACT_APP_COMMUNICATION_MANAGEMENT_URL,
        },
      ],
    },
    {
      title: "Content Management",
      classsChange: "mm-collapse",
      iconStyle: <i className="fas fa-file-alt" />,
      content: [
        {
          title: "Government Orders",
          to: "content/government-orders",
        },
        {
          title: "Circulars",
          to: "content/circulars",
        },
      ],
    },

    ...(userCategoryMain === "2"
      ? [
        {
          title: "Manage Registration",
          classsChange: "mm-collapse",
          // update:"New",
          iconStyle: <i className="fas fa-users" />,
          content: [
            // {
            //   title: "Institution List",
            //   to: "Organization",
            // },
            {
              title: "Individual  List",
              to: "Individual",
            },
          ],
        },
        {
          title: "Manage Verification",
          classsChange: "mm-collapse",
          // update:"New",
          iconStyle: <i className="fas fa-suitcase" />,
          content: [
            // {
            //   title: "Institution  Verification List",
            //   to: "verified-insitute-user",
            // },
            {
              title: "Individual Verification List",
              to: "verified-individual-user",
            },
          ],
        },
        {
          title: "TMS Management",
          classsChange: "mm-collapse",
          iconStyle: <i className="fas fa-building" />,
          content: [
            {
              title: "TMS",
              to: process.env.REACT_APP_TMS_URL,
            },
          ],
        },
        {
          title: "DIGI ACCRED Management",
          classsChange: "mm-collapse",
          iconStyle: <i className="fas fa-certificate" />,
          content: [
            {
              title: "Digital Certificate and Accreditation",
              to:
                process.env.REACT_APP_DIGI_ACCRED_MANAGEMENT_URL ||
                "https://staging-digicert.khelouk.in/",
            },
          ],
        },
        {
          title: "Assessment Management",
          classsChange: "mm-collapse",
          // update:"New",
          iconStyle: <i className="fas fa-map-marker" />,
          content: [
            {
              title: "Assessment Overview",
              to: process.env.REACT_APP_ASSESMENT_MANAGEMENT_URL,
            },
          ],
        },
        {
          title: "Scouting Management",
          classsChange: "mm-collapse",
          // update:"New",
          iconStyle: <i className="fas fa-map-marker" />,
          content: [
            {
              title: "Scouting Overview",
              to: process.env.REACT_APP_SCOUTING_MANAGEMENT_URL,
            },
          ],
        },
        {
          title: "Academy Management",
          classsChange: "mm-collapse",
          iconStyle: <i className="bi bi-calendar-event-fill"></i>,
          content: [
            {
              title: "Dashboard",
              to: "batch-management/dashboard",
            },
            {
              title: "Batches",
              to: "batch-management/batches",
            },
            {
              title: "Calendar",
              to: "batch-management/calendar",
            },
            {
              title: "Attendance",
              to: "batch-management/attendance-report",
            },
          ],
        },

      ]
      : []),
  ]);

  const usertype = localStorage.getItem("user_type");
  const id = localStorage.getItem("id");
  // const userCategoryMain = localStorage.getItem('user_category_main');
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
  } = useContext(ThemeContext);
  const [state, setState] = useReducer(reducer, initialState);
  const [hideOnScroll, setHideOnScroll] = useState(true);
  const { menuItems: dynamicMenuItems, loading: menuLoading } = useMenu();
  const { sideabarmenuDataList, fetchSidebarMenuList, sidebarLoading } = useMenuManagement();
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll],
  );
  const fetchUserData = async () => {
    try {
      const response = await getAllUserProfileList(userCategoryMain, id);
      console.log("response=====>",response)
      const updatedMenu = [...userMenuList];
      // Support staff should land on the Service Provider module
      const serviceProviderMenuForSupportStaff = {
        title: "Service Provider Management",
        classsChange: "mm-collapse",
        iconStyle: <i className="fas fa-briefcase" />,
        content: [
          {
            title: "Service Provider Portal",
            to:
              process.env.REACT_APP_SERVICE_PROVIDER_MODULE_URL ||
              "https://staging-providers.khelouk.in/",
          }, 
        ],
      };
      // setUserData(response?.data?.data);
      if (response?.data?.data?.sub_category_type == 1) {
        updatedMenu.push(
          {
            title: "Schemes & Scholarship",
            to: "grant-scheme",
            classsChange: "mm-collapse",
          },
          {
            title: "Assessment Reports",
            to: "assessment-reports",
            classsChange: "mm-collapse",
          },
           {
            title: "Grant Schemes",
            classsChange: "mm-collapse",
            iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
            content: [
              {
                title: "Schemes Mamagement",
                to: process.env.REACT_APP_SCHEME_FORMBUILDER_MANAGEMENT_URL,
              },
              
            ],
          },
        );
      }
      if (response?.data?.data?.sub_category_type == 2) {
        updatedMenu.push(
          {
            title: "Assessment Management",
            classsChange: "mm-collapse",
            content: [
              {
                title: "Assessment Overview",
                to: process.env.REACT_APP_ASSESMENT_MANAGEMENT_COACH_URL,
              },
            ],
          },
          {
            title: "Scouting Management",
            classsChange: "mm-collapse",
            content: [
              {
                title: "Scouting Overview",
                to: process.env.REACT_APP_SCOUTING_MANAGEMENT_COACH_URL,
              },
            ],
          },
          {
            title: "Grant Schemes",
            classsChange: "mm-collapse",
            iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
            content: [
              {
                title: "Schemes Management",
                to: process.env.REACT_APP_SCHEME_FORMBUILDER_MANAGEMENT_URL,
              },
              
            ],
          },
          {
            title: "Project Management",
            classsChange: "mm-collapse",
            iconStyle: <i className="fas fa-list-alt" />,
            content: [
              {
                title: "pms",
                to: process.env.REACT_APP_PMS_URL,
              },
            ],
          },
          {
            ...serviceProviderMenuForSupportStaff,
          },
          {
            title: "Academy Management",
            classsChange: "mm-collapse",
            iconStyle: <i className="bi bi-calendar-event-fill"></i>,
            content: [
              {
                title: "Dashboard",
                to: "batch-management/dashboard",
              },
              {
                title: "Batches",
                to: "batch-management/batches",
              },
              {
                title: "Calendar",
                to: "batch-management/calendar",
              },
              {
                title: "Attendance",
                to: "batch-management/attendance-report",
              },
            ],
          },
        );
      }
      if (response?.data?.data?.user_category_main == 1) {
        updatedMenu.push(
          {
            title: "My Booking",
            classsChange: "mm-collapse",
            iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
            content: [
              {
                title: "View My Booking",
                to: process.env.REACT_APP_USER_MY_BOOKING_URL,
              },
            ],
          },
          {
            title: "Book Venue Slot",
            classsChange: "mm-collapse",
            iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
            content: [
              {
                title: "Book A Slot",
                to: process.env.REACT_APP_BOOKING_VENUE_SLOT_URL,
              },
            ],
          },
          {
            title: "Event Booking",
            classsChange: "mm-collapse",
            iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
            content: [
              {
                title: "Book A Ticket",
                to: process.env.REACT_APP_TICKET_LIST_URL,
              },
              {
                title: "View My Ticket",
                to: process.env.REACT_APP_MY_TICKET_URL,
              },
            ],
          },
           
        );
      }
      if (response?.data?.data?.user_category_main === 1) {
        updatedMenu.push({
          title: "Logs",
          classsChange: "mm-collapse",
          iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
          to: "user/logs",
        });
      }
      setUserMenuList([...updatedMenu].sort((a, b) => a.title.localeCompare(b.title)));
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  useEffect(() => {
    if (userCategoryMain && id) {
      fetchUserData();
    }
  }, []);


  useEffect(() => {
    const userType = localStorage.getItem("user_type");
    if (!userType || userType === "admin") {
      fetchSidebarMenuList();
    }
  }, [])

  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`dlabnav ${iconHover} ${sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
        ? hideOnScroll > 120
          ? "fixed"
          : ""
        : ""
        }`}
    >

      <PerfectScrollbar className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          <div className={`toggle_sidebar ${isSidebarOpen ? "arrow-container" : "arrow-container-collapse"}`} >
            <div className={`${isSidebarOpen ? "arrow-btn" : "arrow-btn-collapse"}`} onClick={() => {
              dispatch(toggleSidebar());
              NavMenuToggle();
            }}>
              <i className={`fa fa-lg ${isSidebarOpen ? "fa-angle-left" : "fa-angle-right"}`} />
            </div>
          </div>
          {user?.role === "admin" && user?.user_level == USER_LEVEL.ADMIN && (
            <AdminSidebar
              state={state}
              setState={setState}
              menuListData={sideabarmenuDataList}
              sidebarLoading={sidebarLoading}
            />
          )}

          {user?.role === "admin" && (user?.user_level == USER_LEVEL.SUB_ADMIN || user?.user_level == 6 || user?.user_level == 7) && (
            <AdminSidebar
              state={state}
              setState={setState}
             menuListData={sideabarmenuDataList}
            />
          )}

          {usertype === "user" && (
            <UserSidebar
              state={state}
              setState={setState}
              menuListData={userMenuList}
            />
          )}
        </ul>
      </PerfectScrollbar>
    </div>
  );
};
export default SideBar;